import { BffApiClientMolecule } from "@/app/api-client/store"
import { BlockchainFiltersMoleculeReatom } from "@/app/blockchains/filters/blockchain-filters-molecule.reatom"
import { getNftSearchQueryParams } from "@/app/nft/search/result/utils"
import { computed } from "@reatom/core"
import { molecule } from "bunshi"
import { ProfileMoleculeReatom as ProfileMolecule } from "../store/index.reatom"
import { getQueryInput } from "./utils"

export const ProfileListingsMoleculeReatom = molecule((mol) => {
  const { walletAddress } = mol(ProfileMolecule)
  const bffApiClient = mol(BffApiClientMolecule)
  const { blockchainsQueryFilter } = mol(BlockchainFiltersMoleculeReatom)

  // Create dynamic query params that depend on blockchainsQueryFilter
  const queryParamsAtom = computed(() => {
    const blockchains = blockchainsQueryFilter()
    return {
      ...getNftSearchQueryParams(
        bffApiClient,
        getQueryInput(walletAddress, blockchains),
      ),
      refetchInterval: 3000,
    }
  }, "profileListingsQueryParams")

  return { queryParamsAtom }
})
